// This enum is only used in Clients section for different Status value translations
export enum ClientStatus {
  // Deleted = -1,
  Disabled = 0,
  Active = 1
}

(ClientStatus as any).__typeName = 'ClientStatus';
